import getBasePath from '../../functions/api-resource';

const basePath = getBasePath('api', 'configuracao-orcamento');

const configuracaoOrcamentoActions = {
  atualizar: { method: 'PUT', url: `${basePath}` },
  pesquisar: { method: 'GET', url: `${basePath}` },
  pesquisarRateio: { method: 'GET', url: `${basePath}/chave/rateio` },
  pesquisarOrcamento: { method: 'GET', url: `${basePath}/chave/modulo_orcamento` },
};

export default resource => resource(`${basePath}`, {}, configuracaoOrcamentoActions);



// WEBPACK FOOTER //
// ./src/common/resources/configuracao/configuracao-orcamento.js